import service from '@/utils/axios'
// 获取随机码
export function getRandCode() {
  return service.get('/api/221212/user/rand-code')
}

// 发送短信验证码
export function sendSmscode(data) {
  return service.post('/api/221212/user/send-sms-code', data)
}

// 用户登录
export function login(data) {
  return service.post('/api/221212/user/login', data)
}

// 获取开立机构列表
export function getInstitutions() {
  return service.get('/api/221212/open-institutions')
}

// 获取经销商列表
export function getDealers() {
  return service.get('/api/221212/dealers')
}
// 获取是否还有补贴
export function getHaveDiscount(car_tpe, purchase_amount) {
  return service.get(`/api/221212/apply/apply-state?car_tpe=${car_tpe}&purchase_amount=${purchase_amount}`)
}
// 获取提交信息
export function getDetails() {
  return service.get(`/api/221212/apply/info`)
}
// 提交信息
export function apply(data) {
  return service.post(`/api/221212/apply`, data)
}
// 获取申请和补贴额
export function getStat() {
  return service.get(`/api/221212/user/stat`)
}

// 获取微信签名
export function getWxSign(data) {
  return service.post('/api/221212/weixin/share-info', data)
}
